export const GET_EMAIL_TRACKING_START = 'emailTracking/GET_EMAIL_TRACKING_START';
export const GET_EMAIL_TRACKING_FAILED = 'emailTracking/GET_EMAIL_TRACKING_FAILED';
export const GET_EMAIL_TRACKING_COMPLETED = 'emailTracking/GET_EMAIL_TRACKING_COMPLETED';

export const FILTER_EMAIL_TRACKING_START = 'emailTracking/FILTER_EMAIL_TRACKING_START';
export const FILTER_EMAIL_TRACKING_FAILED = 'emailTracking/FILTER_EMAIL_TRACKING_FAILED';
export const FILTER_EMAIL_TRACKING_COMPLETED = 'emailTracking/FILTER_EMAIL_TRACKING_COMPLETED';

export const SOCKET_ADD_ITEM = 'emailTracking/SOCKET_ADD_ITEM';
